export default {
  translations: {
    // Mesmo valor usado nas configurações (defaultNS)
    home: {
      message: 'Bem vindo, ',
    },
    login: {
      text: {
        title: 'Entre na sua conta',
        noAccount: 'Não tem uma conta',
      },
      fields: {
        password: 'Senha',
        user: 'Usuário',
      },
      helpText: 'Nome de usuário ou senha incorreto',
      button: {
        signIn: 'ENTRAR',
        signUp: 'Se cadastre agora',
        forgotPassword: 'Esqueceu sua senha',
      },
    },
    register: {
      text: {
        title: 'Se cadastre agora',
        account: 'Já tem uma conta?',
      },
      fields: {
        password: 'Senha',
        fullName: 'Nome completo',
        email: 'E-mail',
      },
      helpText: {
        password: 'Password must be at least 8 characters',
        fullName: 'Full Name must be at least 3 characters',
      },
      button: {
        register: 'Criar conta gratuita',
        signIn: 'Faça o login',
      },
    },
    order: {
      text: {
        title: 'Pedidos/Devolução',
      },
      buttons: {
        createOrder: 'Criar pedido',
        filter: 'Filtrar',
        export: 'Exportar Pedidos',
      },
      tracking: {
        CREATED: 'Pedido processado',
        CREATE_ORDER_RETURN: 'Criado pedido de retorno',
        FOR_MERCHANT_STORE_IN_BOUND: 'Recebido no Crossdocking',
        FOR_MERCHANT_STORE_IN_STORE: 'Armazenado no e-Box',
        FOR_MERCHANT_STORE_CUSTOMER_TAKEN: 'Retirado pelo usuário',
        FOR_MERCHANT_STORE_COURIER_TAKEN: 'Coletado pelo operador',
        FOR_MERCHANT_STORE_IN_STORE_UPCOMING_EXPIRED:
          'Pedido prestes a expirar',
        FOR_MERCHANT_STORE_IN_STORE_EXPIRED: 'Pedido expirado',
        FOR_MERCHANT_STORE_RETURNED: 'Pedido Retornado ao remetente',
        FOR_MERCHANT_STORE_IN_TRANSIT_TO_STORE: 'Pedido Retornado para loja',
        EXPORTED: 'Pedidos exportados com sucesso',
      },
      status: {
        null: 'Todos',
        Pendente: 'Pendente',
        Aprovado: 'Aprovado',
        Enviado: 'Enviado',
        Esperando: 'Esperando',
        Recebido: 'Recebido',
        Resolvido: 'Resolvido',
        Rejeitado: 'Rejeitado',
        Criado: 'Criado',
        IN_TRANSIT_TO_EBOX: 'Em trânsito',
        STORED: 'Armazenado',
        CUSTOMER_COLLECTED: 'Coletado',
        EXPIRED: 'Expirado',
        EXPIRED_COLLECTED: 'Coletado/expirado',
        EXPIRED_RETURNED: 'Retornado',
        Send: 'Enviado',
        Dispatched: 'Enviado',
        Pending: 'Pendente',
        Received: 'Recebido',
        'Esperando seleção do local de devolução': 'Esperando local',
        'Coletado pela transportadora': 'Coletado',
        Resolved: 'Resolvido',
        Rejected: 'Rejeitado',
        Approved: 'Aprovado',
      },
    },
    profile: {
      title: 'Minha Conta',
    },
    days: {
      saturday: 'Sábado',
      monday: 'Segunda',
      tuesday: 'Terça',
      wednesday: 'Quarta',
      thursday: 'Quinta',
      friday: 'Sexta',
      sunday: 'Domingo',
    },
  },
};
